import { IStorage } from './IStorage';
import { LocalStorageWrapper } from './LocalStorageWrapper';
import { WXTStorageWrapper } from './WXTStorageWrapper';

let storageInstance: IStorage;

export const initializeStorageService = (type?: 'wxt', storage?: unknown) => {
  if (!storageInstance) {
    storageInstance =
      type === 'wxt'
        ? WXTStorageWrapper.getInstance(storage)
        : new LocalStorageWrapper();
  }
};

export const getStorage = (): IStorage => {
  if (!storageInstance) {
    throw new Error(
      'Storage service has not been initialized. Please call initializeStorageService or useInitializeStorage hook first.',
    );
  }
  return storageInstance;
};
